import ApartamentsTable from './ApartamentsTable';

export default ApartamentsTable;
